function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SamoaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_426",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_426)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#C51918"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_426",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_426)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V13.5H12V3H0Z",
        fill: "#2E42A5"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.6742 8.82901L1.87916 9.30897L2.06051 8.37237L1.39844 7.67142L2.29492 7.63352L2.6742 6.75897L3.05348 7.63352H3.94844L3.28789 8.37237L3.48676 9.30897L2.6742 8.82901Z",
        fill: "#FEFFFF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.6742 8.82901L7.87916 9.30897L8.06051 8.37237L7.39844 7.67142L8.29492 7.63352L8.6742 6.75897L9.05348 7.63352H9.94844L9.28789 8.37237L9.48676 9.30897L8.6742 8.82901Z",
        fill: "#FEFFFF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.59916 6.10347L4.85089 6.5552L5.02156 5.67369L4.39844 5.01398L5.24218 4.9783L5.59916 4.1552L5.95613 4.9783H6.79844L6.17675 5.67369L6.36391 6.5552L5.59916 6.10347Z",
        fill: "#FEFFFF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.40963 9.31895L5.94196 9.60128L6.04863 9.05034L5.65918 8.63802L6.18652 8.61572L6.40963 8.10128L6.63274 8.61572H7.15918L6.77062 9.05034L6.8876 9.60128L6.40963 9.31895Z",
        fill: "#FEFFFF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.55657 12.6212L4.43417 13.2988L4.69018 11.9765L3.75549 10.9869L5.02111 10.9334L5.55657 9.69878L6.09203 10.9334H7.35549L6.42296 11.9765L6.70371 13.2988L5.55657 12.6212Z",
        fill: "#FEFFFF"
      })]
    })]
  })]
}));
//# sourceMappingURL=Samoa.js.map